<template>
  <div class="login-body">
    <div class="login-panel"></div>

    <div class="login-content">
      <img
        src="../../../public/mbp_logo.png"
        alt="MBP Group Synergy System"
        style="margin-bottom: 100px"
      />

      <h1><span>SIGN IN</span> To MBP Group Synergy system</h1>
      <p>Welcome, please use the form to sign-in.</p>
      <LoginForm 
        @passwordForgotten="forgottenPassword()"
      />


      <p id="login-quote"><strong>Synergy</strong> - <i>“The combined power of a group of things when they are working together that is greater than the total power achieved by each working separately”</i></p>

    </div>

    <ForgetPassword 
      :showDialog="forgetPasswordDialog"
      :resetDialog="resetForgetPasswordDialog"
      @close="forgetPasswordDialog = false"
    />
  </div>
</template>

<script>

import LoginForm from './LoginForm'
import ForgetPassword from './ForgotPassword'

export default {
  components: {
    LoginForm,
    ForgetPassword
  },
  data: () => ({
    forgetPasswordDialog: false,
    resetForgetPasswordDialog: 0
  }),
  methods: {
    forgottenPassword() {
      this.forgetPasswordDialog = true
      this.resetForgetPasswordDialog++
    }
  }
};
</script>